import { Datagrid, useListContext } from 'react-admin';
import {
    useMediaQuery,
    Box,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { SWIPE_ANIMATIONS, SwipeableRow } from '../table/SwipeableRow';
import { MobileCard } from '../table/MobileCard';

const ResponsiveDatagrid = ({
    children,
    mobile,
    swipeAction = null,
    secondarySwipeAction = null,
    onClick,
    ...props
}) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { data, ids } = useListContext();

    if (!isSmall) {
        return <Datagrid {...props}>{children}</Datagrid>;
    }

    return (
        <Box style={{ backgroundColor: '#f0f0f0', padding: 4 }}>
            {ids.map((id) => {
                const record = data[id];

                return (
                    <SwipeableRow
                        key={id}
                        action={
                            swipeAction
                                ? {
                                      icon: swipeAction.icon,
                                      onSwipe: () => swipeAction.onClick(record),
                                      swipeEnabled: swipeAction.condition
                                          ? swipeAction.condition(record)
                                          : true,
                                      animation:
                                          swipeAction.animation ||
                                          SWIPE_ANIMATIONS.remove,
                                        confirmation: { confirm: swipeAction.confirmation?.confirm || false, message: swipeAction.confirmation?.message || ''}
                                  }
                                : null
                        }
                        
                        secondaryAction={
                            secondarySwipeAction && (secondarySwipeAction.condition ? secondarySwipeAction.condition(record) : true)
                            ? {
                                    icon:
                                        typeof secondarySwipeAction.icon === 'function'
                                            ? secondarySwipeAction.icon(record)
                                            : secondarySwipeAction.icon,
    
                                    onSwipe: () =>
                                        secondarySwipeAction.onClick(record),
    
                                    swipeEnabled:
                                        secondarySwipeAction.condition
                                            ? secondarySwipeAction.condition(record)
                                            : true,
    
                                    animation:
                                        secondarySwipeAction.animation ||
                                        SWIPE_ANIMATIONS.remove,
    
                                    confirmation: {
                                        confirm:
                                            secondarySwipeAction.confirmation?.confirm ||
                                            false,
                                        message:
                                            secondarySwipeAction.confirmation?.message ||
                                            '',
                                    },
                                }
                            : null
                        }
                    >
                        <MobileCard
                            record={record}
                            config={mobile}
                            onClick={() => onClick?.(record)}
                        />
                    </SwipeableRow>
                );
            })}
        </Box>
    );
};

export default ResponsiveDatagrid;